import { useState } from "react";
import Section from "../components/Section/Section.jsx";
import Chip from "../components/Chip/Chip.jsx";
import CardContainer from "../components/Card/CardContainer.jsx";
import { usePageMeta } from "../hooks/usePageMeta";
import "../components/Chip/Chip.css";

function AllWorks() {
  const [activeChip, setActiveChip] = useState("UX/UI Design");

  usePageMeta({
    ogType: "website",
    ogUrl: window.location.href,
  });

  return (
    <Section headingText="All Works">
      <div className="chip-row">
        <Chip
          content="UX/UI Design"
          clicked={activeChip}
          onClick={setActiveChip}
        />
        <Chip
          content="UX Writing"
          clicked={activeChip}
          onClick={setActiveChip}
        />
        <Chip
          content="Content Writing"
          clicked={activeChip}
          onClick={setActiveChip}
        />
      </div>
      <CardContainer isClicked={activeChip} />
    </Section>
  );
}

export default AllWorks;
